import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SocialNetworkProfileServices } from "@/services/bedrock/SocialNetworkProfileServices";

function reviewRepliesQueryKey(userId: string | number, socialIdentityId: string | number, reviewId: string | number) {
  return ["socialProfileReviewReplies", userId, socialIdentityId, reviewId] as const;
}

export const useClearSocialProfileReviewRepliesCache = (
  userId: string | number,
  socialIdentityId: string | number,
  reviewId: string | number
) => {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      queryClient
        .invalidateQueries({ queryKey: reviewRepliesQueryKey(userId, socialIdentityId, reviewId) })
        .catch(console.error),
    [queryClient, userId, socialIdentityId, reviewId]
  );
};

export const useSocialProfileReviewReplies = (
  userId: string | number,
  socialIdentityId: string | number,
  reviewId: string | number,
  enabled: boolean
) => {
  const clearSocialProfileReviewRepliesCache = useClearSocialProfileReviewRepliesCache(
    userId,
    socialIdentityId,
    reviewId
  );

  const query = useQuery({
    queryKey: reviewRepliesQueryKey(userId, socialIdentityId, reviewId),
    queryFn: () => SocialNetworkProfileServices.getReviewReplies(userId, socialIdentityId, reviewId),
    enabled,
  });

  return { ...query, clearSocialProfileReviewRepliesCache };
};
